// extracted by mini-css-extract-plugin
export default {"modalBodyStyle":"importAttendees_modalBodyStyle__iQGX1","modal":"importAttendees_modal__h7Akj"};